<template>
  <b-card no-body>
    <el-table
      v-if="data.length > 0"
      class="table-responsive table"
      header-row-class-name="thead-light"
      :data="data"
    >
      <el-table-column sortable label="ID" prop="name" min-width="auto">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{ row.id }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column sortable label="Grupo" min-width="150px" prop="date">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.nombre_grupo
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column sortable label="Aula" min-width="120px" prop="date">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.nombre_clase
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="Catequista responsable"
        min-width="135px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <template>
              <b-col>
                <b-row
                  v-for="(item, index) in row.catequistas"
                  class="mb-2"
                  :key="index"
                >
                  {{ getNombreCatequista(item) }}
                </b-row>
              </b-col>
            </template>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column label="Editar" min-width="50px" prop="date">
        <template v-slot="{ row }">
          <b-row>
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-edit"
                circle
                @click="editargrupo(row)"
              ></el-button
            ></b-col>
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-delete"
                circle
                @click="eliminarGrupo(row.id, row.nombre_grupo)"
              ></el-button
            ></b-col>
          </b-row>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</template>
<script>
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  computed: {
    grupo() {},
  },
  methods: {
    getNombreCatequista(item) {
      return item.nombre + " " + item.apellido1 + " " + item.apellido2;
    },
    editargrupo(id) {
      this.$emit("editarGrupo", id);
    },
    eliminarGrupo(id, nombre) {
      swal
        .fire({
          text: `¿Esta Seguro de que desea eliminar el grupo ${nombre}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f5365c",
          cancelButtonColor: "#616365",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.$emit("eliminarGrupo", id);
          }
        });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.separador {
  border-left: 1px solid rgb(2, 2, 2);
  height: auto;
}
</style>
